<template>
  <FullPageProgressCircular v-if="!errorMessage" />
  <div v-else-if="errorMessage">{{ errorMessage }}</div>
</template>

<script lang="ts">

import { useSecurity } from "../stores/security";
import FullPageProgressCircular from "../components/FullPageProgressCircular.vue";
import { applyConnectSettings } from "../utils/connectSettings";
import _ from "lodash";

async function buildSecurityContext() {
  let { corvinaHost, accessToken, organizationId, instanceId, locale } = this.$route?.query || {};

  if (corvinaHost && organizationId && accessToken) {
    try {
      let security = await useSecurity();

      await security.buildCorvinaConnect({ corvinaHost, instanceId, locale });

      applyConnectSettings(this.$vuetify, security);

      this.errorMessage = "";
      this.$router.replace({ path: "/alarm-manager" });
    } catch (error) {
      console.error(error);
      this.errorMessage = `${this.$t('unableLoadDomainData', {corvinaHost, organizationId})}`;
    }
  } else {
    this.errorMessage = this.$t('YouMustProvideThreeQuerystringParams');
  }
}


export default {
  name: "Home",
  data() {
    return {
      errorMessage: "",
    };
  },
  async created() {
    await buildSecurityContext.call(this);
  },
  async mounted() {
    //await buildSecurityContext.call(this);
  },
  async updated() {
    await buildSecurityContext.call(this);
  },
  components: { FullPageProgressCircular }
};
</script>
